import { getActiveClients } from "@/services/clientService";
import { getCategories, storeTasks } from "@/services/taskService";
import { getUsersActives } from "@/services/userService";

const state = {
    taskCategories: [],
    activeUsers: [],
    activeClients: [],
    tasks: [],
    loggedUser: null,
    isTaskModalVisible: false,
  };
  
const mutations = {
    SET_TASK_CATEGORIES(state, categories) {        
        state.taskCategories = categories;        
    },
    SET_ACTIVE_USERS(state, users) {
        state.activeUsers = users;
    },
    SET_ACTIVE_CLIENTS(state, clients) {
      state.activeClients = clients;
    },
    SET_LOGGED_USER(state, user) {
        state.loggedUser = user;
    },
    ADD_TASK(state, task) {
      state.tasks.push(task);  // Adiciona a nova tarefa à lista de tarefas no estado
    },
    SET_TASK_MODAL_VISIBILITY(state, visibility) {      
      state.isTaskModalVisible = visibility;
    },
};

const actions = {
      async storeTask({ commit }, taskData) {        
        try {

            // Chamada à API para cadastrar a tarefa
            const response = await storeTasks(taskData);
            
            commit('ADD_TASK', response.data);  // Se você estiver mantendo uma lista de tarefas no estado

            return response.data;
        } catch (error) {
            console.error('Erro ao cadastrar tarefa:', error);
            throw error;  // Relançar o erro para ser tratado no componente
        }
    },
    async fetchTaskCategories({ commit }) {
      try {
        const response = await getCategories();        
        commit('SET_TASK_CATEGORIES', response.data);
      } catch (error) {
        console.error('Error fetching task categories:', error);
      }
    },
    async fetchActiveUsers({ commit }) {
      try {
        const response = await getUsersActives();
        commit('SET_ACTIVE_USERS', response.data);
      } catch (error) {
        console.error('Error fetching active users:', error);
      }
    },
    async fetchActiveClients({ commit }) {
      try {
        const response = await getActiveClients();
        commit('SET_ACTIVE_CLIENTS', response.data);
      } catch (error) {
        console.error('Error fetching active users:', error);
      }
    },
    setLoggedUser({ commit }, user) {
      commit('SET_LOGGED_USER', user);
    },    
    openTaskModal({ commit }) {
      console.log('chegando aqui no open >> ', commit)      
      commit('SET_TASK_MODAL_VISIBILITY', true);
    },
    closeTaskModal({ commit }) {      
      commit('SET_TASK_MODAL_VISIBILITY', false);
    },
};
  
const getters = {
    taskCategories: (state) => state.taskCategories,
    activeUsers: (state) => state.activeUsers,
    activeClients: (state) => state.activeClients,
    loggedUser: (state) => state.loggedUser,
    isTaskModalVisible: (state) => state.isTaskModalVisible,
};
  
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  